module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia2.c76277ae.jpg";